import { CursorTypes, changeCursorTo as defaultChangeCursorTo } from '../utils/changeCursor';

export const waitForSpinnerToShowUp = ({ changeCursorTo = defaultChangeCursorTo, action, callback }) => {
  changeCursorTo(CursorTypes.WAIT);
  setTimeout(() => action(() => {
    changeCursorTo(CursorTypes.DEFAULT);
    if (callback) {
      callback();
    }
  }), 1000); // It needs to be 1 second so that the spinner has enough time to load before exporting will freeze the whole application
};
